import { CheckboxProps } from "@mui/material"
import React from "react"

export enum MeasureConversion {
    HEIGHT = "HEIGHT",
    DISTANCE = "DISTANCE",
}

export interface CustomCheckboxProps extends CheckboxProps {
    disableSelectAll?: boolean
}

export interface NexHeaderCellPropsBase {
    label?: string
    convertType?: MeasureConversion
}

export enum TableVariant {
    input = "input",
    time = "time",
    select = "select",
    autocomplete = "autocomplete",
    textTooltip = "textTooltip",
}

interface TableColumnBase<R> {
    variant?: TableVariant.time | TableVariant.input | TableVariant.textTooltip
    id: keyof R
    label: string
    align?: string
    minWidth?: number
    maxWidth?: number
    width?: number | string
    primary?: boolean
    convertType?: MeasureConversion
    inputAlign?: string
    required?: boolean
    cellError?: (rowId: number) => boolean
    /**
     * Overrides the table variant
     */
    renderCell?: (rowId: number, row: R) => React.ReactNode
}

// TODO Ideally we would make these strings generic, but to do so we ought to stop using an OR on TableColumnBase or
//  with options, because one needs that type and the other doesn't.
interface TableColumnWithOptions<R> extends Omit<TableColumnBase<R>, "variant"> {
    variant: TableVariant.select | TableVariant.autocomplete
    options: readonly string[]
    allowNoSelection?: boolean
    disableOptions?: (row: R) => string[]
}

export type TableColumn<R> = TableColumnBase<R> | TableColumnWithOptions<R>

export interface TableRowType {
    disableRow?: boolean
    nonSelectable?: boolean
}

export type UpdateTableRows<R> = (updatedRows: R[], selectedRowsChanged?: R[], rowAdded?: R) => void

export type HandleChange<V, R> = (value: V, columnId: keyof R, rowId: number) => void

export type HandleSelect = (shiftClick: boolean, rowId?: number) => void

export type HandleDeleteRow = false | ((rowId: number) => void)

export type HandlePaste<R> = (event: React.ClipboardEvent<HTMLDivElement>, rowId: number, colId: keyof R) => void

export type GetTableRowId<R> = (row: R) => number
